import * as React from 'react'

export interface IMaterialInputProps {
  placeholder: string
  disableMaterialPlaceholder?: boolean
  onChange?: (value: string) => void
  value?: any
  required?: boolean
  type?: string
  step?: number
  defaultValue?: any
  disabled?: boolean
  autofocus?: boolean
}

export interface IMaterialInputState {
  hasValue: boolean
  hasFocus: boolean
  disableMaterialPlaceholder: boolean
  type: string
}

export class MaterialInput extends React.Component<IMaterialInputProps, IMaterialInputState> {
  private inputElement: HTMLInputElement

  componentWillMount() {
    this.setState({
      hasValue: this.props.defaultValue || this.props.value ? true : false,
      hasFocus: false,
      disableMaterialPlaceholder: !!this.props.disableMaterialPlaceholder,
      type: this.props.type || 'text'
    })
  }

  componentDidMount() {
    if (this.props.autofocus) {
      this.inputElement.focus()
    }
  }

  onChange(e: React.SyntheticEvent<HTMLInputElement>): void {
    const value = e.currentTarget.value
    const hasValue = !!value

    this.setState({ hasValue })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value)
    }
  }

  onFocusChange(hasFocus: boolean): void {
    this.setState({ hasFocus })
  }

  reset() {
    this.setState({ hasValue: false })
    this.inputElement.value = ''
  }

  render() {
    return (
      <div className={`material-input-group ${this.state.hasValue ? 'hasValue' : ''} ${this.state.hasFocus ? 'hasFocus' : ''} ${this.state.disableMaterialPlaceholder ? 'disableMaterialPlaceholder' : ''}`}>
        {this.state.disableMaterialPlaceholder ? null : (<label className="material-input-placeholder">{this.props.placeholder}</label>)}

        <input className="form-control material-input"
          disabled={this.props.disabled}
          type={this.state.type}
          required={this.props.required}
          defaultValue={this.props.defaultValue}
          value={this.props.value}
          placeholder={this.state.disableMaterialPlaceholder ? this.props.placeholder : null}
          step={this.props.step}
          onChange={(e) => this.onChange(e)}
          onFocus={(e) => this.onFocusChange(true)}
          onBlur={(e) => this.onFocusChange(false)}
          ref={(ref) => this.inputElement = ref}
        />
      </div>
    )
  }
}

export default MaterialInput



// WEBPACK FOOTER //
// ./src/app/components/material/MaterialInput/index.tsx